export default __webpack_public_path__ + "static/media/dr-yeshodha-s-mahesh.323f04a5.jpg";